import React from 'react';
import { useParams, Link as RouterLink } from 'react-router-dom';
import { Box, Typography, Button, CardMedia, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import publicEngagementData from '../data/PublicEngagementData.json';

const PublicEngagementEventDetail = () => {
  const { slug, eventSlug } = useParams();
  const { t, i18n } = useTranslation();
  const language = i18n.language;

  const category = publicEngagementData.find((entry) => entry.slug === slug);
  const event = category?.events?.find((entry) => entry.slug === eventSlug);

  if (!category || !event) {
    return (
      <Box sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="h4">{t('public_engagement.not_found', 'Page not found')}</Typography>
      </Box>
    );
  }

  const title = language === 'es' ? event.title_es : event.title_en;
  const categoryTitle = language === 'es' ? category.title_es : category.title_en;

  // Function to handle image click - opens in new window
  const handleImageClick = (imagePath) => {
    const fullImageUrl = `${process.env.PUBLIC_URL}${imagePath}`;
    window.open(fullImageUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <Box sx={{ p: { xs: 2, md: 4 }, maxWidth: 1100, mx: 'auto', minHeight: '80vh' }}>
      <Button component={RouterLink} to={`/public-engagement/${category.slug}`} variant="outlined" sx={{ mb: 3 }}>
        {t('public_engagement.back', 'Back to engagement page')}
      </Button>

      <Typography variant="h4" gutterBottom align="center" sx={{ fontSize: { xs: '1.75rem', md: '2.25rem' }, mb: 3 }}>
        {title}
      </Typography>

      <Typography variant="subtitle1" color="text.secondary" sx={{ mb: 3, fontSize: '1rem', textAlign: 'center' }}>
        {categoryTitle}
      </Typography>

      <Typography variant="body1" sx={{ lineHeight: 1.8, whiteSpace: 'pre-line', fontSize: '1rem', maxWidth: 900, mx: 'auto', textAlign: 'justify' }}>
        {event.body || t('public_engagement.placeholder', 'Content will be added here later.')}
      </Typography>

      {event.gallery && event.gallery.length > 0 && (
        <Grid container spacing={3} sx={{ mt: 4, justifyContent: 'center' }}>
          {event.gallery.map((image, index) => (
            <Grid item xs={12} sm={6} md={4} key={`${image}-${index}`}>
              <Box
                sx={{
                  height: 320, // Increased from 240 to 320
                  overflow: 'hidden',
                  borderRadius: 2,
                  boxShadow: 2,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: '#f5f5f5',
                  cursor: 'pointer', // Add pointer cursor to indicate clickability
                  transition: 'transform 0.2s ease-in-out', // Optional: add hover effect
                  '&:hover': {
                    transform: 'scale(1.02)', // Optional: subtle zoom on hover
                  },
                }}
                onClick={() => handleImageClick(image)} // Add click handler
              >
                <CardMedia
                  component="img"
                  image={`${process.env.PUBLIC_URL}${image}`}
                  alt={`${title}-gallery-${index + 1}`}
                  sx={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    display: 'block',
                  }}
                />
              </Box>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default PublicEngagementEventDetail;